import {
    CarConfigStep,
    getCarConfigUrl,
} from "../../../../common-deprecated/features/apheleia/utils/carConfigNavigationUtils";
import { getCarImage } from "../../shared-logic/utils/imageUtils";
import { useGradeSelectorSelector } from "../redux/hooks";
import { selectModel } from "../redux/slices/GradeSelectorModelSlice";
import type { GradeSelectorStateType } from "../redux/store";
import type { BodyTypeType, EquipmentType, GradeType } from "./types/Model";
import type {
    ApiGradeBodyEngineTransmissionWheeldriveCarType,
    SBRockarCarType,
} from "../../../../common-deprecated/types/ApiModel";
import type { GradeSelectorCategoryType } from "../redux/slices/GradeSelectorFiltersSlice";

export const useVisibleEquipment = (
    forceFilterPath?: string,
    currentFilter?: (GradeSelectorCategoryType & {
        fullPath: string;
        root: string;
    })[],
): EquipmentType[] => {
    const { equipment } = useGradeSelectorSelector(selectModel);

    if (forceFilterPath) {
        return equipment.filter(({ groupPath }) => forceFilterPath === groupPath);
    }

    return equipment.filter(({ groupPath }) => {
        if (!currentFilter || currentFilter.length === 0) return false;

        return currentFilter.some((filter) => filter.fullPath === groupPath);
    });
};

/**
 * Get image for current grade and bodyType
 *
 * @param grade
 * @param bodyType
 * @param car
 * @param width
 * @param height
 * @param angle
 * @param type
 * @param colourCodes
 * @param carExtrasAndPacks
 * @returns
 */
export const useGradeImage = (
    grade: GradeType,
    bodyType: BodyTypeType,
    car: ApiGradeBodyEngineTransmissionWheeldriveCarType | SBRockarCarType,
    width: number,
    height: number,
    angle: number,
    type: "jpg" | "png" = "jpg",
    colourCodes?: string,
    carExtrasAndPacks?: { extras: string[]; packs: string[] },
): ReturnType<typeof getCarImage> => {
    const commonSettings = useGradeSelectorSelector((state: GradeSelectorStateType) => state.commonSettings);
    const { id } = useGradeSelectorSelector(selectModel);

    return getCarImage(
        commonSettings,
        angle,
        {
            modelId: id,
            gradeId: grade.id,
            bodyTypeId: bodyType.id,
            carId:
                (car as ApiGradeBodyEngineTransmissionWheeldriveCarType).CarID ||
                (car as SBRockarCarType).vehicle.base.externalId,
        },
        {
            type,
            width,
            height,
            bgColour: type === "png" ? "" : "FFFFFF",
        },
        {
            colorCode: colourCodes,
            packIds: carExtrasAndPacks?.packs,
            optionIds: carExtrasAndPacks?.extras,
        },
    );
};

export const useCarConfigUrl = (
    car: ApiGradeBodyEngineTransmissionWheeldriveCarType | SBRockarCarType,
    carConfigStep?: CarConfigStep,
    colour?: { colourId: string; colourCode: string },
    extras?: string[],
    packs?: string[],
): string => {
    const commonSettings = useGradeSelectorSelector((state: GradeSelectorStateType) => state.commonSettings);
    const model = useGradeSelectorSelector(selectModel);
    const enableSpeedboatUrl = useGradeSelectorSelector((state) => state.gradeSelectorSettings.enableSpeedboatUrl);

    return getCarConfigUrl(
        commonSettings,
        model.id,
        model.code,
        (car as ApiGradeBodyEngineTransmissionWheeldriveCarType).CarID ||
            (car as SBRockarCarType).vehicle.base.externalId,
        carConfigStep || CarConfigStep.Configure,
        colour,
        undefined,
        undefined,
        extras,
        packs,
        enableSpeedboatUrl,
    );
};
